module.exports = __webpack_public_path__ + "img/HeadphonesOutlined.91f95ef5.svg";